import React, { useState } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Dashboard from "../../components/Dashboard";

import { PubNub } from "../../api/Realtime";
import API from "../../api";
import World from "../../world";

import * as Sentry from '@sentry/nextjs';

const pubNubSubKey = process.env.NEXT_PUBLIC_PUB_NUB_SUB_KEY;
const pn = new PubNub(pubNubSubKey);
const api = new API(pn);
const world = new World(api, {
    short_domain: process.env.NEXT_PUBLIC_SHORT_DOMAIN,
});
const stripePubKey = process.env.NEXT_PUBLIC_STRIPE_PUB_KEY;
const uploadsBaseURL = process.env.NEXT_PUBLIC_UPLOADS_BASE_URL;

const Page = () => {
    return (
        <>
            <Head>
                <title>Dashboard - TacBoard</title>
                <meta name="description" content="Manage your event phone number, pictures and guests. Delete unwanted photos, block or invite guests." />
                <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato:400,300,100|Gochi+Hand|Lobster" />
            </Head>

            <Dashboard world={world} stripe_pub_key={stripePubKey} uploads_base_url={uploadsBaseURL} />
        </>
    );
}

export default Page;
